import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import {useState} from 'react'

export default function usePDF({ref, name = 'export'}) {
  const [loading, setLoading] = useState(false)

  const downloader = () => {
    setLoading(true)

    const element = ref.current
    if (!element) {
      setLoading(false)
      return
    }

    setTimeout(async () => {
      const originalOverflow = element.style.overflow
      element.style.overflow = 'visible'

      const originalHeight = element.scrollHeight

      const canvas = await html2canvas(element, {
        scale: 1.25,
        width: element.scrollWidth,
        height: originalHeight,
        windowWidth: element.scrollWidth,
        windowHeight: originalHeight,
        useCORS: true,
        scrollY: 0,
      })

      element.style.overflow = originalOverflow

      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'a4')

      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      const imgProps = pdf.getImageProperties(imgData)
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width

      let heightLeft = imgHeight
      let position = 0

      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight)
      heightLeft -= pdfHeight

      while (heightLeft > 0) {
        position = heightLeft - imgHeight
        pdf.addPage()
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight)
        heightLeft -= pdfHeight
      }

      pdf.save(`${name}.pdf`)
      setLoading(false)
    }, 300)
  }

  return {
    downloader,
    loading,
  }
}
